export default "__VITE_ASSET__xyGuzOSr__"